// extracted by mini-css-extract-plugin
export default {"service":"Service_service__a7NA6"};